module.exports = __webpack_public_path__ + "img/dsci0159.9bd2833e.jpg";